export var CLASS_STUDENT_PROGRESS_REPOSITORY = 'CLASS_STUDENT_PROGRESS_REPOSITORY';